import { MainLayout } from "../layouts";
import { SocialKajian } from "../components";
import { LiputanSection } from "../layouts/HomePage";
import { useGetDataFromApi } from "../Func/GlobalFunction";
import { get_thumbnail } from "../utils/variable";

const StrukturOrganisasi = () => {
  const { data, loading } = useGetDataFromApi("contentsByCodename/struktur");

  const finalData =
    data && data.length > 0
      ? data.filter((item) => {
          const jenjang = item.rjenjang_id === 3;
          const lembaga = item.rlembaga_id === 0;
          const sekolah = item.rsekolah_id === 0;
          return jenjang && lembaga && sekolah;
        })
      : [];

  const imageSrc =
    finalData && finalData.length > 0 && finalData[0].gambar
      ? `${get_thumbnail}${finalData[0].gambar}`
      : null;

  return (
    <MainLayout title={"Struktur Organisasi - Dikmen Idrisiyyah"}>
      <div className="flex flex-col lg:flex-row lg:justify-between gap-8 mb-10">
        {/* Gambar Struktur */}
        {loading ? (
          <div className="max-w-lg w-full aspect-video bg-gray-100 animate-pulse rounded-xl" />
        ) : imageSrc ? (
          <img
            src={imageSrc}
            alt="Struktur Organisasi"
            className="max-w-lg w-full object-contain rounded-xl"
          />
        ) : (
          <div className="max-w-lg w-full aspect-video bg-gray-50 border border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center text-gray-400 gap-2">
            <svg
              width="40"
              height="40"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
            >
              <path d="M4 16l4-4 4 4 4-6 4 6" />
              <rect x="3" y="3" width="18" height="18" rx="2" />
            </svg>
            <span className="text-sm">Gambar tidak tersedia</span>
          </div>
        )}

        <SocialKajian />
      </div>
      <LiputanSection />
    </MainLayout>
  );
};

export default StrukturOrganisasi;
